export enum LoggerStorageKey {
  BASE_LOGGER = 'lps-base-logger',
  EDITOR_LOGGER = 'lps-editor-logger',
  LPC_LOGGER = 'lps-lpc-logger',
  SHOW_LOGGER = 'lps-show-logger',
  PREVIEW_MULTI_LOGGER = 'lps-preview-multi-logger',
  SHOW_THANK_YOU_PAGE_LOGGER = 'lps-show-thank-you-page-logger',
  TEMPLATE_BUILDER_LOGGER = 'lps-template-builder-logger',
}
